import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react/dist/iconify.js';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import GlobalSelectField from '../../components/mui/GlobalSelectField';
import {
  addRefundRequest,
  clearLeadData,
  clearStudentData,
  getAddedRequests,
  getAllActiveCourses,
  getCoursesUndeAdmnNo,
  getCoursesUnderLeadId,
  getLeadDetails,
  getLeadListForOtherIncome,
  getProjects,
  getRefundCalculation,
  getStudentDetails,
  getStudents,
  getSubjectUnderCourseEnrolmentid,
} from '../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import FetchedStudentDetails from './FetchedStudentDetails';
import RefundCalculation from './RefundCalculation';
import { refundRequestReason } from '../../utils/constants/GlobalStaticData';
// import GlobalFileUploadComponent from '../../components/Fileupload/GlobalFileUploadComponent';
import GlobalMultiSelectFormik from '../../components/mui/GlobalMultiSelectFormik';
import { useNavigate } from 'react-router-dom';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';
import GlobalAllTypeFileUpload from '../../components/Fileupload/GlobalAllTypeFileUpload';

const NewRefundRequest = () => {
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(1);
  const [autoCompleteList, setAutoCompleteLIst] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const handleApiResponse = useHandleApiResponse();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, stundentslist, allcourses, subjects, studentData, refundCalculation, leadData } = useSelector(
    (state) => state.refund,
  );

  useEffect(() => {
    if (!Array.isArray(stundentslist)) return;
    if (stundentslist.length === 0) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
    setAutoCompleteLIst((prev) => {
      if (page === 1) {
        return stundentslist;
      }
      const existing = new Set(prev.map((i) => i.admn_no));
      const filtered = stundentslist.filter((i) => !existing.has(i.admn_no));

      return [...prev, ...filtered];
    });
  }, [stundentslist, page]);
  const isRefundCondition = (refund_type, refund_category) => refund_type === 2 && refund_category === 1;

  const validationSchema = Yup.object({
    refund_type: Yup.number().required('Refund type is required'),
    refund_category: Yup.number().when('refund_type', {
      is: (refund_type) => refund_type == 2,
      then: (schema) => schema.required('Category is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    student: Yup.number().required('Student is required'),
    course: Yup.number().required('Course is required'),
    requestReason: Yup.string().min(3, 'write minimum 3 letter').required('Reason Is required'),

    refund_ac_bankname: Yup.string().when([], {
      is: () => studentData?.account_type === 'GCC',
      then: (schema) => schema.required('Bank Name is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    refund_account_no: Yup.string().required('Account number is required'),
    refund_account_holder: Yup.string().required('Holder Name is required').min(2, 'required minimum 2 letter'),

    refund_account_ifsc: Yup.string().required('IFSC is required'),
    // refundAttachmentsDisplayName: Yup.string().required('Attachemnt is required'),
    refundAttachments: Yup.array().of(Yup.string()).min(1, 'Attachment is required'),

    // refund Type 2 and Category 1
    refundToBePaid: Yup.number().when(['refund_type', 'refund_category'], {
      is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('required'),
    }),
    refundReason: Yup.string().when(['refund_type', 'refund_category'], {
      is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Reason is required').min(3, 'required minimum 3 letter'),
    }),
    request_date: Yup.string()
      .nullable()
      .when(['refund_type', 'refund_category'], {
        is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Requested Date is required').typeError('Requested Date is required'),
      }),
    reason_for_refund: Yup.number().when(['refund_type', 'refund_category'], {
      is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Reason is required').typeError('Reason is required'),
    }),
    parentAttachements: Yup.array()
      .of(Yup.string())
      .when(['refund_type', 'refund_category'], {
        is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.min(1, 'Attachment is required').required('Attachment is required'),
      }),

    /* parentAttachementsDisplayName: Yup.string().when(['refund_type', 'refund_category'], {
      is: (refund_type, refund_category) => isRefundCondition(refund_type, refund_category),
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Attachment is required'),
    }), */
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      refund_type: '',
      refund_category: '',
      student: null,
      course: '',
      subject: null, //NOT MANDATORY

      //CALCULATION DATA START
      refundToBePaid: '',
      refundReason: '',
      //CALCULATION DATA END

      //REQUEST DETAILS SECTION START
      request_date: null,
      parentAttachements: [],
      parentAttachementsDisplayName: '',
      reason_for_refund: '',
      //REQUEST DETAILS SECTION END

      // session_held: '',
      parent_connected: false,

      paymentSelectedIds: [],
      refundAttachments: [],
      refundAttachmentsDisplayName: '',
      requestReason: '',
      remarks: '',

      // BANK DETAILS START
      refund_account_no: '',
      refund_account_holder: '',
      refund_account_ifsc: '',
      refund_ac_bankname: '',
      // BANK DETAILS END

      paymentSelectedIds: [],
      paymentSelections: [],
      isBatchRefund: false,
    },

    validationSchema: validationSchema,
    onSubmit: (values) => {
      let data;

      if (formik.values.refund_category != 1) {
        //NORMAL FLOW
        data = {
          type: 1,
          expense_course_enrollment_id: values.course,
          expense_course_batch_id: null,
          expense_transaction_date: null,
          expense_amount: values.refundToBePaid,
          subject_enrollment_id: values.subject || null,
          refund_account: 0,
          refund_ac_holder: values.refund_account_holder,
          refund_ac_no: values.refund_account_no,
          refund_ifsc: values.refund_account_ifsc,
          parent_requested_date: values.request_date,
          is_parent_connected: values.parent_connected == 'true' ? 1 : 0,
          parent_reason: values.reason_for_refund
            ? refundRequestReason.find((r) => r.id == values.reason_for_refund)?.reason
            : null,
          attachmentUrl: values.refundAttachments,
          parent_connection_attachmentUrl: values.parentAttachements,
          refund_reason: values.requestReason,
          refund_remarks: values.remarks,
          expense_remarks: values.refundReason,
          isBatchRefund: values.isBatchRefund,
        };
      } else {
        data = {
          refund_account: 0, //FOR API
          type: 2,
          refund_ac_holder: values.refund_account_holder,
          refund_ac_no: values.refund_account_no,
          refund_ifsc: values.refund_account_ifsc,
          refund_reason: values.requestReason,
          attachmentUrl: values.refundAttachments,
          non_admission_data: values.paymentSelections,
        };
      }
      dispatch(addRefundRequest(data)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            navigate('/my-workspace/refund-request');
          },
        });
      });
    },
  });

  useEffect(() => {
    formik.setFieldValue('refund_category', '');
    formik.setFieldValue('student', null);
    formik.setFieldValue('course', '');
    formik.setFieldValue('subject', '');
    if (formik.values.refund_type == 1) {
      dispatch(getStudents({ search: '', page: 1, limit: 50 }));
    }
  }, [formik.values.refund_type]); //WHILE CHANGING THE FIRST DROP DOWN CLEAR ALL THE FIELDS

  useEffect(() => {
    if (formik.values.refund_category) {
      setAutoCompleteLIst([]); //STUDENT LIST CLEARED
      setPage(1); //RESET PAGE
      formik.setFieldValue('student', null);
      formik.setFieldValue('course', '');
      formik.setFieldValue('subject', '');
      if (formik.values.refund_category != 1) {
        dispatch(getStudents({ search: '', page: 1, limit: 50 }));
      } else {
        dispatch(getLeadListForOtherIncome({ search: '', page: 1, limit: 50 }));
      }
    }
  }, [formik.values.refund_category]);

  useEffect(() => {
    if (formik.values.student) {
      formik.setFieldValue('course', '');
      formik.setFieldValue('subject', '');

      if (formik.values.student && formik.values.refund_category != 1) {
        dispatch(clearStudentData()); //NEWLY ADDED
        dispatch(getCoursesUndeAdmnNo(formik.values.student)); //FETCHING COURSES UNDER ADMISSION NO
      } else {
        dispatch(clearLeadData()); //NEWLY ADDED
        dispatch(getCoursesUnderLeadId(formik.values.student)); //FETCHING COURSES UNDER LEAD ID
      }
    }
  }, [formik.values.student]);

  useEffect(() => {
    if (formik.values.course) {
      formik.setFieldValue('subject', '');
      if (formik.values.course && formik.values.refund_category != 1) {
        dispatch(clearLeadData());
        dispatch(getSubjectUnderCourseEnrolmentid(formik.values.course));
        dispatch(
          getStudentDetails({
            course_enrollment_id: formik.values.course,
            subject_enrollment_id: formik.values.subject,
          }),
        );
      } else {
        dispatch(clearStudentData());
        dispatch(getLeadDetails(formik.values.course));
      }
    }
  }, [formik.values.course]);

  useEffect(() => {
    if (formik.values.course && formik.values.refund_category != 1 && formik.values.subject) {
      dispatch(clearLeadData());
      dispatch(
        getStudentDetails({ course_enrollment_id: formik.values.course, subject_enrollment_id: formik.values.subject }),
      );
    }
  }, [formik.values.subject]);

  useEffect(() => {
    if (formik.values.request_date && formik.values.course) {
      dispatch(
        getRefundCalculation({
          course_enrollment_id: formik.values.course,
          subject_enrollment_id: formik.values.subject,
          refund_request_date: formik.values.request_date,
        }),
      );
    }
  }, [formik.values.request_date, formik.values.subject, formik.values.course]);

  const handleChangeSetValue = (event, option, formikName, key = 'id') => {
    formik.setFieldValue(formikName, option ? option[key] : '');
  };

  useEffect(() => {
    const selected = formik.values.paymentSelectedIds || [];
    const data = leadData?.payments || [];

    const structured = selected.map((val) => {
      const findedObject = data.find((d) => d.hold_amt_for_cart_id == val);
      return {
        hold_amt_for_cart_id: val,
        holdamount_refund_amount: findedObject?.amount,
        paymentValue: findedObject?.value || '',
        maximumRefundAmount: findedObject?.amount || '',
      };
    });
    formik.setFieldValue('paymentSelections', structured);
  }, [formik.values.paymentSelectedIds]);

  return (
    <>
      <GlobalWrapper title={'New Refund Request'}>
        <Box sx={{ padding: 1, width: '100%' }}>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  p: 2,
                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;',
                  mb: 2,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <GlobalSelectField
                      options={{
                        formik,
                        name: 'refund_type',
                        label: 'Refund Type',
                        data: [
                          { id: 1, value: 'Tution Fee' },
                          { id: 2, value: 'Hold Amount/Other Income' },
                        ],
                        keys: {
                          id: 'id',
                          value: 'value',
                        },
                        sx: { width: '100%' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {formik.values.refund_type == 2 ? (
                      <>
                        <GlobalSelectField
                          disabled={formik.values.refund_type != 2}
                          options={{
                            formik,
                            name: 'refund_category',
                            label: 'Category',
                            data: [
                              { id: 1, value: 'Hold Amount' },
                              // { id: 2, value: 'Emi Processing Fee' },
                              // { id: 3, value: 'Other Income' },
                            ],
                            keys: {
                              id: 'id',
                              value: 'value',
                            },
                            sx: { width: '100%' },
                          }}
                        />
                      </>
                    ) : (
                      <Paper elevation={3} sx={{ padding: 1 }}>
                        <Box width={'100%'} display="flex" alignItems="center" gap={1}>
                          <Typography>Batch assigned</Typography>
                          <Switch
                            checked={formik.values.isBatchRefund}
                            onChange={(e) => formik.setFieldValue('isBatchRefund', e.target.checked)}
                          />
                        </Box>
                      </Paper>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={autoCompleteList}
                      getOptionLabel={(option) => option.display_name || ''}
                      value={autoCompleteList?.find((s) => s.admn_no == formik.values.student) || null}
                      onChange={(e, option) => handleChangeSetValue(e, option, 'student', 'admn_no')}
                      loading={loading}
                      filterOptions={(x) => x}
                      onInputChange={(e, value, reason) => {
                        if (reason === 'input') {
                          setSearchText(value);
                          setPage(1);

                          if (formik.values.refund_category == 1) {
                            dispatch(getLeadListForOtherIncome({ search: value, page: 1, limit: 50 }));
                          } else {
                            dispatch(getStudents({ search: value, page: 1, limit: 50 }));
                          }
                        }
                      }}
                      ListboxProps={{
                        onScroll: (e) => {
                          const listboxNode = e.currentTarget;
                          const isBottom =
                            listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 5;

                          if (isBottom && !loading && hasMore) {
                            const nextPage = page + 1;
                            setPage(nextPage);

                            if (formik.values.refund_category == 1) {
                              dispatch(
                                getLeadListForOtherIncome({
                                  search: searchText,
                                  page: nextPage,
                                }),
                              );
                            } else {
                              dispatch(
                                getStudents({
                                  search: searchText,
                                  page: nextPage,
                                }),
                              );
                            }
                          }
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={`${formik.values.refund_category == 1 ? 'Select Lead' : 'Select Student'}`}
                          placeholder="Search"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <Icon icon="eos-icons:loading" width={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      fullWidth
                      name="course"
                      options={allcourses || []}
                      getOptionLabel={(option) => option.course_name || ''}
                      value={allcourses?.find((c) => c.course_enrollment_id == formik.values.course) || null}
                      onChange={(e, option) => handleChangeSetValue(e, option, 'course', 'course_enrollment_id')}
                      renderInput={(params) => (
                        <TextField
                          disabled
                          fullWidth
                          autoComplete="off"
                          {...params}
                          label={`${formik.values.refund_category == 1 ? 'Lead Choosen Course' : 'Course'}`}
                        />
                      )}
                    />
                  </Grid>

                  {formik.values.refund_category != 1 && (
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        disabled={formik.values.refund_category == 1}
                        fullWidth
                        name="subject"
                        options={subjects}
                        getOptionLabel={(option) => option.subject_name || ''}
                        value={subjects.find((s) => s.subject_enrollment_id == formik.values.subject) || null}
                        onChange={(e, option) => handleChangeSetValue(e, option, 'subject', 'subject_enrollment_id')}
                        renderInput={(params) => (
                          <TextField
                            disabled
                            fullWidth
                            autoComplete="off"
                            {...params}
                            label={`${formik.values.refund_category == 1 ? 'Subject (NOT Required)' : 'Subject'}`}
                          />
                        )}
                      />
                    </Grid>
                  )}
                </Grid>

                {loading && (
                  <Box my={2}>
                    <Typography variant="body2" mb={1}>
                      Loading...
                    </Typography>
                    <LinearProgress />
                  </Box>
                )}

                {/* CATEGORY TYPE 1 SECTON START*/}
                {formik.values.refund_category == 1 && Object.keys(leadData).length > 0 && (
                  <Box
                    mt={2}
                    sx={{
                      border: '1px solid #f5f5f5ff', // light gray
                      p: 2,
                      borderRadius: 2,
                    }}
                  >
                    <Stack direction={'row'} spacing={2} mt={1}>
                      <TextField
                        disabled={true}
                        fullWidth
                        label="Lead Name"
                        name="lead_name"
                        value={leadData?.lead_name || 'Nill'}
                      />
                      <TextField
                        disabled={true}
                        fullWidth
                        label="Project Name"
                        name="project_name"
                        value={leadData?.project_name || 'Nill'}
                      />
                    </Stack>
                    <Stack direction={'row'} spacing={2} mt={2}>
                      <TextField
                        disabled={true}
                        fullWidth
                        label="OGA Name"
                        name="oga_name"
                        placeholder="OGA Name"
                        value={leadData?.oga_name || ''}
                      />

                      <TextField
                        disabled={true}
                        fullWidth
                        label="Sale Amount"
                        name="total_sale_amount"
                        placeholder="Sale Amount"
                        value={leadData?.sale_amount || ''}
                      />
                    </Stack>
                    <Stack direction={'row'} spacing={2} mt={2}>
                      <GlobalMultiSelectFormik
                        disabled={false}
                        label={'Payments List'}
                        formik={formik}
                        name="paymentSelectedIds"
                        data={leadData?.payments || []}
                        // data={[
                        //   {
                        //     date: '2025-11-21',
                        //     value: '10000.00 ( 21-11-2025 12:00 AM )',
                        //     amount: 10000,
                        //     hold_amt_for_cart_id: 99,
                        //   },
                        //   {
                        //     date: '2025-11-22',
                        //     value: '7500.00 ( 22-11-2025 09:30 AM )',
                        //     amount: 7500,
                        //     hold_amt_for_cart_id: 100,
                        //   },
                        //   {
                        //     date: '2025-11-23',
                        //     value: '12000.50 ( 23-11-2025 04:15 PM )',
                        //     amount: 12000.5,
                        //     hold_amt_for_cart_id: 101,
                        //   },
                        //   {
                        //     date: '2025-11-24',
                        //     value: '5000.00 ( 24-11-2025 11:00 AM )',
                        //     amount: 5000,
                        //     hold_amt_for_cart_id: 102,
                        //   },
                        //   {
                        //     date: '2025-11-25',
                        //     value: '18000.00 ( 25-11-2025 06:45 PM )',
                        //     amount: 18000,
                        //     hold_amt_for_cart_id: 103,
                        //   },
                        // ]}
                        keys={{ id: 'hold_amt_for_cart_id', value: 'value' }}
                      />
                    </Stack>
                    <Stack mt={2} gap={1}>
                      {formik.values.paymentSelections.map((item, index) => (
                        <Box key={item.hold_amt_for_cart_id} sx={{ display: 'flex', gap: 2 }}>
                          <TextField fullWidth label="Chosen Payment" value={item.paymentValue} disabled />

                          <TextField
                            type="number"
                            fullWidth
                            label="Refund Amount"
                            name={`paymentSelections[${index}].holdamount_refund_amount`}
                            value={item.holdamount_refund_amount}
                            error={
                              Number(item.holdamount_refund_amount) < 1 ||
                              Number(item.holdamount_refund_amount) > Number(item.maximumRefundAmount)
                            }
                            helperText={
                              Number(item.holdamount_refund_amount) > Number(item.maximumRefundAmount)
                                ? `Maximum allowed refund is ${item.maximumRefundAmount}`
                                : ''
                            }
                            onChange={formik.handleChange}
                            onWheel={(e) => e.target.blur()}
                            inputProps={{
                              inputMode: 'numeric',
                              pattern: '[0-9]*',
                              onWheel: (e) => e.target.blur(),
                            }}
                          />
                        </Box>
                      ))}
                    </Stack>

                    <TextField
                      sx={{ mt: 2 }}
                      fullWidth
                      label="Reason"
                      name="requestReason"
                      rows={3}
                      placeholder="Type your remarks here..."
                      multiline
                      value={formik.values.requestReason}
                      onChange={formik.handleChange}
                      error={formik.touched.requestReason && Boolean(formik.errors.requestReason)}
                      helperText={formik.touched.requestReason && formik.errors.requestReason}
                    />
                    <Box mt={2}>
                      {/* <GlobalFileUploadComponent
                        formik={formik}
                        fileDisplayName="refundAttachmentsDisplayName"
                        fileBackendLink="refundAttachments"
                        accept=".pdf,image/*"
                        label="Payment Proof Attachment"
                      /> */}
                      <GlobalAllTypeFileUpload
                        accept="image/*,video/*,audio/*,application/pdf"
                        dbFolderName="refund"
                        formik={formik}
                        label="Refund Request Attachment"
                        formikNameArray="refundAttachments"
                        multiple
                      />
                      {formik.touched.refundAttachments && Boolean(formik.errors.refundAttachments) && (
                        <FormHelperText error>{formik.errors.refundAttachments}</FormHelperText>
                      )}
                    </Box>

                    <Box mt={2}>
                      <Typography variant="subtitle2" gutterBottom mb={1}>
                        Add Bank Details For Non Enrollment
                      </Typography>
                      <Stack direction={'column'} spacing={2}>
                        <TextField
                          fullWidth
                          label="Account no"
                          name="refund_account_no"
                          placeholder="Account Number"
                          value={formik.values.refund_account_no}
                          onChange={formik.handleChange}
                          error={formik.touched.refund_account_no && Boolean(formik.errors.refund_account_no)}
                          helperText={formik.touched.refund_account_no && formik.errors.refund_account_no}
                        />
                        <TextField
                          fullWidth
                          label="Account Holder Name"
                          name="refund_account_holder"
                          placeholder="Account Holder"
                          value={formik.values.refund_account_holder}
                          onChange={formik.handleChange}
                          error={formik.touched.refund_account_holder && Boolean(formik.errors.refund_account_holder)}
                          helperText={formik.touched.refund_account_holder && formik.errors.refund_account_holder}
                        />
                        <TextField
                          fullWidth
                          label="IFSC Code"
                          name="refund_account_ifsc"
                          placeholder="Ifsc code"
                          value={formik.values.refund_account_ifsc}
                          onChange={formik.handleChange}
                          error={formik.touched.refund_account_ifsc && Boolean(formik.errors.refund_account_ifsc)}
                          helperText={formik.touched.refund_account_ifsc && formik.errors.refund_account_ifsc}
                        />
                      </Stack>
                    </Box>
                  </Box>
                )}
              </Box>

              {/* CATEGORY TYPE 1 SECTON END*/}

              {formik.values.student && formik.values.refund_category != 1 && Object.keys(studentData).length > 0 && (
                <>
                  <FetchedStudentDetails studentData={studentData} />
                  {/* <RefundCalculation refundData={refundCalculation} formik={formik} /> */}
                </>
              )}

              {formik.values.student && formik.values.refund_category != 1 && Object.keys(studentData).length > 0 && (
                <Box
                  sx={{
                    width: '100%',
                    borderRadius: 2,
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;',
                    mb: 2,
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      padding: 2,
                    }}
                  >
                    <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
                      Request Details
                    </Typography>
                  </Box>
                  <Box sx={{ p: 3 }}>
                    <Stack direction={'column'} spacing={2}>
                      <Stack direction={'row'} spacing={2}>
                        <Stack direction={'row'} spacing={2} width={'100%'}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Parent Refund Request Date"
                              format="DD-MM-YYYY"
                              disableFuture
                              value={formik.values.request_date ? dayjs(formik.values.request_date) : null}
                              onChange={(value) =>
                                formik.setFieldValue('request_date', value ? dayjs(value).format('YYYY-MM-DD') : null)
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: formik.touched.request_date && Boolean(formik.errors.request_date),
                                  helperText: formik.touched.request_date && formik.errors.request_date,
                                },
                              }}
                            />
                          </LocalizationProvider>

                          <Box>
                            {/* <GlobalFileUploadComponent
                              formik={formik}
                              fileDisplayName="parentAttachementsDisplayName"
                              fileBackendLink="parentAttachements"
                              accept=".pdf,image/*"
                              label="Attachment"
                            /> */}
                            <GlobalAllTypeFileUpload
                              // accept="image/*,video/*,audio/*,application/pdf"
                              accept="image/*"
                              dbFolderName="refund"
                              formik={formik}
                              label="Refund Request Date"
                              formikNameArray="parentAttachements"
                              multiple
                            />
                            {formik.touched.parentAttachements && Boolean(formik.errors.parentAttachements) && (
                              <FormHelperText error>{formik.errors.parentAttachements}</FormHelperText>
                            )}
                          </Box>
                        </Stack>
                        <GlobalSelectField
                          options={{
                            formik,
                            name: 'reason_for_refund',
                            label: 'Reason',
                            data: refundRequestReason,
                            keys: {
                              id: 'id',
                              value: 'reason',
                            },
                            sx: { width: '100%' },
                          }}
                        />
                      </Stack>
                      <Stack direction={'row'} spacing={2}>
                        <TextField
                          disabled={true}
                          fullWidth
                          label="Class Start Date"
                          name="class_start_date"
                          placeholder="class start date"
                          value={
                            studentData.admission_confirmed_date
                              ? studentData?.admission_confirmed_date?.split(' ')[0]
                              : ''
                          }
                        />
                        <TextField
                          disabled
                          fullWidth
                          label="Session Held"
                          name="session_held"
                          placeholder="Add no of sessions held"
                          value={studentData.no_of_sessions}
                        />
                      </Stack>
                      <Stack direction={'row'} spacing={2}>
                        <TextField
                          disabled={true}
                          fullWidth
                          label="Enrollment Date"
                          name="EnrollmentDate"
                          placeholder="Enrollment Date"
                          value={
                            studentData.admission_confirmed_date
                              ? studentData?.admission_confirmed_date?.split(' ')[0]
                              : ''
                          }
                        />
                        <FormControl fullWidth>
                          <FormLabel id="parent-connected-label">Parent Connected?</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="parent-connected-label"
                            name="parent_connected"
                            value={formik.values.parent_connected}
                            onChange={formik.handleChange}
                          >
                            <FormControlLabel value="true" control={<Radio />} label="Yes" />
                            <FormControlLabel value="false" control={<Radio />} label="No" />
                          </RadioGroup>
                        </FormControl>
                      </Stack>

                      <Box>
                        {/* <GlobalFileUploadComponent
                          formik={formik}
                          fileDisplayName="refundAttachmentsDisplayName"
                          fileBackendLink="refundAttachments"
                          accept=".pdf,image/*"
                          label="Refund Request Attachment"
                        /> */}
                        <GlobalAllTypeFileUpload
                          accept="image/*,video/*,audio/*,application/pdf"
                          dbFolderName="refund"
                          formik={formik}
                          label="Refund Request Attachment"
                          formikNameArray="refundAttachments"
                          multiple
                        />
                        {formik.touched.refundAttachments && Boolean(formik.errors.refundAttachments) && (
                          <FormHelperText error>{formik.errors.refundAttachments}</FormHelperText>
                        )}
                      </Box>
                      <TextField
                        fullWidth
                        label="Reason"
                        name="requestReason"
                        rows={3}
                        placeholder="Type your remarks here..."
                        multiline
                        value={formik.values.requestReason}
                        onChange={formik.handleChange}
                        error={formik.touched.requestReason && Boolean(formik.errors.requestReason)}
                        helperText={formik.touched.requestReason && formik.errors.requestReason}
                      />
                      <TextField
                        fullWidth
                        label="Remarks"
                        name="remarks"
                        rows={3}
                        placeholder="Type your remarks here..."
                        multiline
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                      />

                      {formik.values.refund_category != 1 &&
                        formik.values.request_date &&
                        Object.keys(studentData).length > 0 && (
                          <>
                            <RefundCalculation refundData={refundCalculation} formik={formik} />
                          </>
                        )}

                      <Box
                        sx={{
                          border: '1px solid',
                          // borderColor: 'primary.main',
                          padding: 3,
                          borderRadius: 2,
                        }}
                      >
                        <Typography variant="subtitle2" gutterBottom mb={1}>
                          Add Bank Details
                        </Typography>
                        <Stack direction={'column'} spacing={2}>
                          <TextField
                            fullWidth
                            label="Bank Name"
                            name="refund_ac_bankname"
                            placeholder="Bank Name"
                            value={formik.values.refund_ac_bankname}
                            onChange={formik.handleChange}
                            error={formik.touched.refund_ac_bankname && Boolean(formik.errors.refund_ac_bankname)}
                            helperText={formik.touched.refund_ac_bankname && formik.errors.refund_ac_bankname}
                          />
                          <TextField
                            fullWidth
                            label="Account no"
                            name="refund_account_no"
                            placeholder="Account Number"
                            value={formik.values.refund_account_no}
                            onChange={formik.handleChange}
                            error={formik.touched.refund_account_no && Boolean(formik.errors.refund_account_no)}
                            helperText={formik.touched.refund_account_no && formik.errors.refund_account_no}
                          />
                          <TextField
                            fullWidth
                            label="Account Holder Name"
                            name="refund_account_holder"
                            placeholder="Account Holder"
                            value={formik.values.refund_account_holder}
                            onChange={formik.handleChange}
                            error={formik.touched.refund_account_holder && Boolean(formik.errors.refund_account_holder)}
                            helperText={formik.touched.refund_account_holder && formik.errors.refund_account_holder}
                          />
                          <TextField
                            fullWidth
                            label="IFSC Code"
                            name="refund_account_ifsc"
                            placeholder="Ifsc code"
                            value={formik.values.refund_account_ifsc}
                            onChange={formik.handleChange}
                            error={formik.touched.refund_account_ifsc && Boolean(formik.errors.refund_account_ifsc)}
                            helperText={formik.touched.refund_account_ifsc && formik.errors.refund_account_ifsc}
                          />
                        </Stack>
                      </Box>
                    </Stack>
                  </Box>
                </Box>
              )}

              {((Boolean(formik.values.student) && Boolean(formik.values.course)) ||
                formik.values.refund_category == 1) && (
                <Box mt={3} sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <Button size="medium" color="secondary" variant="outlined">
                      Cancel
                    </Button>
                    <Button disabled={loading} color="secondary" variant="contained" size="medium" type="submit">
                      {loading ? 'Please wait...' : 'Submit Request'}
                    </Button>
                  </Stack>
                </Box>
              )}
            </Form>
          </FormikProvider>
        </Box>
      </GlobalWrapper>
    </>
  );
};

export default NewRefundRequest;
